export class ProductTypeId {
    public static InvestmentTypeId = "eb5f9259-3262-467d-b98e-8cb1034369e1";
    public static InsuranceTypeId = "e24bb865-2cdf-4d60-90ed-4cc7089aea40";
    public static LoanTypeId = "d0cb93da-f8ab-4df5-a0e3-523e7fc51a00";
    public static CreditTypeId = "9805cbb7-6a1c-4a06-9c85-ffa6f895402f";
}
